import cn from 'classnames';
import { ConditionalRender } from '@ui';
import { getTimezoneWithCity } from '@/utils/helpers';

type TimezoneDisplayProps = {
  value: string;
  date: Date;
  displayLabels: boolean;
  timeZoneFieldLabel?: string;
};

export const TimezoneDisplay = ({ value, date, displayLabels, timeZoneFieldLabel }: TimezoneDisplayProps) => (
  <div
    className={cn([
      'w-full bg-base-60 px-3 flex flex-col justify-center rounded-lg text-base-20 text-m-r truncate',
      displayLabels ? 'h-14' : 'h-8',
    ])}
  >
    <ConditionalRender show={displayLabels && !!timeZoneFieldLabel}>
      <div className="text-xs text-base-30 mb-1">{timeZoneFieldLabel}</div>
    </ConditionalRender>
    <div className="truncate">{getTimezoneWithCity(value, date.valueOf() > 0 ? date : new Date())}</div>
  </div>
);
